FiltersMdl.controller( 'SubCategoriesCtrl', [ 'SubcategoriesHandlerSrv', 'category', 'sub_category', 'HuesSrv', function ( SubcategoriesHandlerSrv, category, sub_category, HuesSrv ) {



	HuesSrv.setFilter('color_fan', false );
	HuesSrv.setFilter('effect_fan', false);
	HuesSrv.setFilter('family', false );




	this.handler = SubcategoriesHandlerSrv;
	this.handler.subcategories = [ sub_category ];
	this.handler.category = category;



}]);